import Vue from 'vue';

export default new Vue({
    created(){
        this.$on('languageChanged', (language) => {
            return language;
        })
    },
});